import { createSlice } from "@reduxjs/toolkit";

const createInitialDashboardState = () => {
  return {
    allConfigs: {},
    processedValues: {
      colorBarRange: {},
    },
  };
};

let initialState = {};

const dynamicDashboardSlice = createSlice({
  initialState,
  name: "dynamicDashboard",
  reducers: {
    initializeDashboard(state, action) {
      const { appName } = action.payload;
      if (!state[appName]) {
        state[appName] = createInitialDashboardState();
      }
    },
    resetDashboard(state, action) {
      const { appName } = action.payload;
      if (!state[appName]) {
        state[appName] = createInitialDashboardState();
      }
    },
    setColorBarRange: (state, { payload }) => {
      if (state[payload.appName]?.processedValues?.colorBarRange !== undefined)
        state[payload.appName].processedValues.colorBarRange[payload.chartId] = payload.range;
    },
    setSingleConfig: (state, { payload }) => {
      state[payload.appName].allConfigs[payload.id] = payload.config;
    },
  },
});

export const { initializeDashboard, resetDashboard, setColorBarRange, setSingleConfig } = dynamicDashboardSlice.actions;
export default dynamicDashboardSlice.reducer;
